import withLazy from '../../hoc/with-lazy';
export const TooltipLazy = withLazy({
    importFn: async () => import(/* webpackChunkName: "wc-tooltip" */ './tooltip'),
    errorHandling: { type: 'HANDLE' },
    loader: { type: 'CHILDREN' },
});
//# sourceMappingURL=tooltip-lazy.js.map